














import Vue from 'vue';
import { OutlinedTextInput } from '@/components/ds';

export default Vue.extend({
  components: { OutlinedTextInput },
  props: {
    currentSubscriptionNumber: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      enemSubscriptionNumber: this.currentSubscriptionNumber,
      hasError: false,
    };
  },
  methods: {
    numberFormatter(value: string) {
      const matchedValue = value.match(/(\d{1,12})/g);

      return matchedValue ? matchedValue[0] : '';
    },
    inputHandler(value: string) {
      this.hasError = value.length < 12;

      this.$emit('input', value, this.hasError);
    },
  },
});
